import script from "./ActivityList.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityList.vue?vue&type=script&setup=true&lang=js"

import "./ActivityList.vue?vue&type=style&index=0&id=0e31affe&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e31affe"]])

export default __exports__